var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"w-full"},[_c('label',{staticClass:"text-base text-grey-800 mb-2"},[_vm._v(" "+_vm._s(_vm.$t('frontend_groovesell_link_checkout_popup_modal_text', {pagesAppTitle: _vm.whitelabelAppData('pages').title}))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }